import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { BiTrackApi } from '../bi-track-api';
import type { BiTrackParams } from '../../types';

@injectable()
export class BiTrackApiImpl extends PsHttpService implements BiTrackApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    biTrack(dataTrack: BiTrackParams) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/tracking/add',
            data: dataTrack,
        }).then((res) => {
            return res.status as boolean
        })
    }
}
